import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LotsService } from 'src/app/services/lots.service';
import { fetchData, newTableData } from './table-data.actions';
import { concatMap, map, mergeMap } from 'rxjs';

@Injectable()
export class FetchTableDataEffect {
  constructor(private actions$: Actions, private lotsService: LotsService) {}
  fetchTableData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchData),
      mergeMap((action) => {
        // console.log('data table effect action', action);
        // fetches the lots with specified market_type
        return this.lotsService
          .watch({ limit: action.limit, marketType: action.marketType })
          .valueChanges.pipe(
            map((res) => {
              return newTableData({
                newLots: res.data.lots,
                market: action.marketType,
              });
            })
          );
      })
    );
  });
}
